import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from './constants';

const lazy = {
    SkillDetailsPage: lazyLoad(async () => {
        const { SkillDetailsPage } = await import('./SkillDetails');

        return { default: SkillDetailsPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.skill-details.headlines.title',
        page: lazy.SkillDetailsPage,
        path: route.patterns.skillDetails,
    },
];
